import { DefaultService } from "../DefaultService";

export default class B2BClienteTipoNegocioService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll(...params) {
        return this._http.get(encodeURI(`${this._env}/b2btiponegocio/cliente/findall.json?param=${params}`), this._headers)
        .then(res => {
            return res.body;
        },
        err => {
            this.handleError(err);
        });
    }

    insertBulk(assClienteTipoNegocio) {
        return this._http.post(`${this._env}/b2btiponegocio/cliente/insert-bulk`, assClienteTipoNegocio, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
    }
}